import Error from './Error';

export default {
  path: 'error',

  getComponents(location, cb) {
    cb(null, Error);
  },
};
